export default __webpack_public_path__ + "static/website3-c2b8221b7fd9df51d178fced02401b14.png";